"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.setReactModalAppElement = void 0;
var react_modal_1 = __importDefault(require("react-modal"));
function setReactModalAppElement() {
    try {
        react_modal_1.default.setAppElement("#footer-wrapper");
    }
    catch (e) {
        console.warn(e);
        console.warn("Screen readers will suffer.");
    }
}
exports.setReactModalAppElement = setReactModalAppElement;
